define('modules/editor/models/property_groups/social',['require','exports','module','./base','../../social_manager','../../views/elements/social_facebook','../../views/elements/social_twitter','../../views/elements/social_google'],function(require, exports, module){
	"use strict";
  var BasePropertyGroup = require("./base"),
      SocialManager = require("../../social_manager"),
      SocialViews = {
        "social:facebook": require("../../views/elements/social_facebook"),
        "social:twitter": require("../../views/elements/social_twitter"),
        "social:google": require("../../views/elements/social_google")
      };

  module.exports = BasePropertyGroup.extend({
    name: "social",
    properties: ["sharedUrl", "active", "counter"],
    defaultValues: {
      sharedUrl: "",
      active: true,
      counter: true 
    },
    initialize: function() {
      this.set("scriptTag", SocialManager[this.name] && SocialManager[this.name].scriptTag);
    },
    validators: {
      sharedUrl: function(attrs){
        var isValid = this.isValidUrl(attrs.sharedUrl);
        return !attrs.sharedUrl || isValid;
      }
    },
    applyStyles: function($el){
      var key = this.name.split(":")[1] || "",
          config = SocialManager[key] || {},
          el = $el.children(".js-" + key);

      if (!this.get("active")){
        el.css("display", "none");
      } else {
        el.css("display", "");
      }

      if (this.hasChanged("counter") || !el.children().length){
        this.set("counter", this.get("counter"));
        el.empty();
        if (config.scriptId) $("#" + config.scriptId).remove();
        var widget = (new SocialViews[this.name]({model:this}));
        el.append(widget.render().el);
        el.append(config.scriptTag);
        if (config.reloadCode) el.append(config.reloadCode);
      }
    }
  });
});

